import styled from "styled-components";
import bg01 from "@public/assets/main/bg01.png";
import bgMo01 from "@public/assets/main/bg-mo01.png";
import { SIZES } from "@/components/constants";
import { useMediaQuery } from "react-responsive";
import { useLocale } from "next-intl";
import { useGetMainVisualQuery } from "@/api/visualApi";
import { useState } from "react";
import {convertVimeo, convertYoutube, getVimeoId} from "@/utils";

const HeroSection = () => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });

    const locale = useLocale();
    const { data: visualData, isLoading } = useGetMainVisualQuery({ locale });
    const [videoLoaded, setVideoLoaded] = useState(false);
    if (isLoading || !visualData?.result) return null;
    const pcMedia = visualData?.data?.pc?.img_url || visualData?.data?.pc?.url || bg01?.src;
    const moMedia = visualData?.data?.mo?.img_url || visualData?.data?.mo?.url || bgMo01?.src;
    const media = isTablet ? moMedia : pcMedia;
    const isVimeo = media && (media.includes("vimeo.com") || media.includes("player.vimeo.com"));
    const isYoutube = media && (media.includes("youtube.com") || media.includes("youtu.be"));
    const isVideo = isVimeo || isYoutube;
    const vimeoId = getVimeoId(media);
    const thumbnail = isVimeo ? `https://vumbnail.com/${vimeoId}.jpg` : null;

    return (
        <SectionWrap
            $pcBg={!isVideo ? pcMedia : isVimeo ? thumbnail : null}
            $moBg={!isVideo ? moMedia : isVimeo ? thumbnail : null}
            $isVideo={isVideo}
        >
            {isVideo && (
                <VideoWrap $loaded={videoLoaded}>
                    <iframe
                        src={isVimeo ? convertVimeo(media) : convertYoutube(media)}
                        onLoad={() => setVideoLoaded(true)}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                </VideoWrap>
            )}
            <h1
                className={"text-wrap"}
                dangerouslySetInnerHTML={{
                    __html: !isTablet
                        ? visualData.data.pc.content
                        : visualData.data.mo.content
                }}
            />
        </SectionWrap>
    );
};

const SectionWrap = styled.section`
    position: relative;
    width: 100%;
    overflow: hidden;
    padding-top: ${props => props.$isVideo ? "56.25%" : "800px"};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-image: ${props => props.$pcBg ? `url(${props.$pcBg})` : "none"};

    .text-wrap{
        width: 100%;
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 64px;

        *:not(font){
            all: revert;
        }
    }

    @media (max-width: ${SIZES.TABLET}) {
        padding-top: ${props => props.$isVideo ? "177.77%" : "640px"};
        background-image: ${props => props.$moBg ? `url(${props.$moBg})` : "none"};

        .text-wrap{
            font-size: 28px;
        }
    }
`;

const VideoWrap = styled.div`
    position: absolute;
    inset: 0;
    overflow: hidden;
    z-index: 1;
    opacity: ${props => (props.$loaded ? 1 : 0)};
    transition: opacity .6s ease;

    iframe{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        min-width: 100%;
        min-height: 100%;
        transform: translate(-50%, -50%);
        border: none;
        pointer-events: none;
    }
`;


// const SectionWrap = styled.section`
//     position: relative;
//     width: 100%;
//     height: calc(100vh - 80px);
//     overflow: hidden;
//
//     background-repeat: no-repeat;
//     background-position: center;
//     background-size: cover;
//     background-image: ${props => props.$pcBg ? `url(${props.$pcBg})` : "none"};
//
//     .text-wrap{
//         width: 100%;
//         position: absolute;
//         z-index: 2;
//         top: 50%;
//         left: 50%;
//         transform: translate(-50%, -50%);
//         font-size: 64px;
//
//         *:not(font){
//             all: revert;
//         }
//     }
//
//     @media (max-width: ${SIZES.TABLET}) {
//         background-image: ${props => props.$moBg ? `url(${props.$moBg})` : "none"};
//
//         .text-wrap{
//             font-size: 28px;
//         }
//     }
// `;
//
//
// const VideoWrap = styled.div`
//     position: absolute;
//     inset: 0;
//     overflow: hidden;
//     z-index: 1;
//     opacity: ${props => (props.$loaded ? 1 : 0)};
//     transition: opacity .6s ease;
//
//     iframe{
//         position: absolute;
//         top: 50%;
//         left: 50%;
//         width: 177.77vh;
//         height: 100vh;
//
//         min-width: 100vw;
//         min-height: 56.25vw;
//
//         transform: translate(-50%, -50%);
//         border: none;
//         pointer-events: none;
//     }
// `;

export default HeroSection;